import "./Lamp.css"
import Product1 from "../Components/Product1"
import Lamp1 from "../images/lamp1.webp"
import Lamp2 from "../images/lamp2.webp"
import Lamp3 from "../images/lamp3.jpg"
import Lamp4 from "../images/lamp4.webp"
import Lamp5 from "../images/lamp5.webp"
import Lamp6 from "../images/lamp6.webp"
import Lamp7 from "../images/lamp7.webp"
import Lamp8 from "../images/lamp8.webp"
import Lamp9 from "../images/lamp9.webp"


export default function Lamp() {

  return (
    <div className="stdivinhome">
      <div className="add"><img src={Lamp9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="lamp1"prdName="COMBO-FRAME" img={Lamp1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="lamp2" prdName="SINGLE FRAMES" img={Lamp2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1> 

          </div>

          <div className="home__prd1">

          
          <Product1  id="lamp3"prdName="SET FRAMES" img={Lamp3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="lamp4"prdName="COMBO " img={Lamp4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="lamp5"prdName="SINGLE A4 FRAME" img={Lamp5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1  id="lamp6"prdName="A4 FRAMES" img={Lamp6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1  id="lamp7" prdName="TREE FRAME CLUB" img={Lamp7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="lamp8"prdName="SET FRAMES" img={Lamp8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}